



export const exampleContext = 'Le port d’Anvers voit plusieurs exploitant ferroviaire opérés.' +
                        'Chacun d’entre eux nécessite des infrastructures de support locales (blocs sanitaires, espaces de stockage d’équipements, dépôts, etc.). ' +
                        'Afin de répondre aux enjeux d’efficience et de sécurité IKOS a été mandaté par le port d’Anvers et Infrabel pour mener à bien les études ' +
                        'de conception d’un « Locomotive Service Centre (LSC) ». Ce LSC vise à centraliser les besoins d’infrastructures des exploitants au sein ' +
                        'd’un site unique.'


export const exampleObjectives = '- Analyse des besoins des différents exploitants ferroviaires du port d’Anvers; \n ' +
'- Définition du fonctionnement du LSC intégrant fonctions et installations relatives; \n '+
'- Analyse des coûts relatives à chacune des fonctionnalités identifiées; \n '+
'- Modèles de gestion du LSC intégrant bâtiments, titularités, etc.; \n '+
'- Conception d’un schéma d’aménagement du LSC.'


export const exampleActivity = '- Rapport des besoins; \n '+
'- Liste des fonctions et coûts relatifs; \n '+
'- Modèle de fonctionnement; \n '+
'- Schéma d’aménagement; \n '+
'- Présentation étendue pour la prise de décision quant à la création du LSC.'

